import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslationService } from '../../services/translation.service';

@Pipe({
  name: 't',
  standalone: true,
  // Impure so a language change re-renders existing labels; the cache below keeps each call O(1).
  pure: false
})
export class TranslatePipe implements PipeTransform {
  private readonly translations = inject(TranslationService);

  private cachedKey?: string;
  private cachedParams?: string;
  private cachedLanguage?: string;
  private cachedVersion?: number;
  private cachedValue = '';

  /**
   * Resolves a translation key for use in templates: {{ 'lbl_all' | t }}.
   */
  transform(key: string, params?: Record<string, string | number>): string {
    const language = this.translations.language();
    const version = this.translations.version();
    const paramsKey = params ? JSON.stringify(params) : '';

    if (key === this.cachedKey && paramsKey === this.cachedParams && language === this.cachedLanguage && version === this.cachedVersion) {
      return this.cachedValue;
    }

    this.cachedKey = key;
    this.cachedParams = paramsKey;
    this.cachedLanguage = language;
    this.cachedVersion = version;
    this.cachedValue = this.translations.t(key, params);
    return this.cachedValue;
  }
}
